import styled, { css } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

export const CodeText = styled(Text)`
  display: flex;
  gap: ${props => props.theme.spacing.sp4};
  align-items: center;
  color: ${props => props.theme.colors.accent.on};
  padding: 2px ${props => props.theme.spacing.sp4};
  background-color: ${props => props.theme.colors.disabled.surface};
  width: fit-content;
  border-radius: 2px;

  ${props =>
    props.variant === 'proposed' &&
    css`
      color: ${props => props.theme.colors.ai.onSurface};
      background-color: ${props => props.theme.colors.ai.surface};
    `}

  ${props =>
    props.variant === 'match' &&
    css`
      color: ${props => props.theme.colors.success.onSurface};
      background-color: ${props => props.theme.colors.success.surface};
    `}
`
